export const projects = [
  {
    title: "Chic Station Webapp",
    subtitle: "MERN Stack",
    description:
      "Serve as a user-friendly interface for customers, allowing them to easily browse through a wide range of nail, lash and gluta services.",
    image: "./project-1.gif",
  },
  {
    title: "AppetiteGuru",
    subtitle: "Bootstrap",
    description:
      " Restaurant app that implements a search functionality that allows users to search for restaurants based on location.",
    image: "./project-2.gif",
  },
  {
    title: "Netflix-like Webapp",
    subtitle: "RestfulAPI, TV-MAZE",
    description:
      "With its extensive database of shows, it's easy to find detailed information about any TV program",
    image: "./project-3.gif",
  },
  {
    title: "Chic Station Test-Admin app",
    subtitle: "MERN Stack",
    description:
      "The admin app serves as the control panel for managing and updating various aspects of the nail web app, including prices and the gallery.",
    image: "./Project-4.gif",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Express.js",
  "Node",
  "Mongodb",
  "Material UI",
  "Bootstrap",
  "Tailwind",
];



// WEBPACK FOOTER //
// ./src/data.js